import { VisuallyHidden } from "@radix-ui/react-visually-hidden";
import { useTranslation } from "react-i18next";

import { useRegisterStore } from "~/stores/use-register-store";
import { Button } from "../ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../ui/dialog";
import { ScrollArea } from "../ui/scroll-area";
import MutationForm from "./mutation-form";

export default function MutationDialog() {
  const { mutationDialogOpen, setMutationDialogOpen } = useRegisterStore();
  const { t } = useTranslation("common");

  const handleDialog = (open: boolean) => {
    setMutationDialogOpen(open);
  };

  return (
    <Dialog open={mutationDialogOpen} onOpenChange={handleDialog}>
      <DialogContent className="max-w-xl w-full">
        <DialogHeader>
          <DialogTitle>{t("drawer_mutation")}</DialogTitle>
          <VisuallyHidden>
            <DialogDescription></DialogDescription>
          </VisuallyHidden>
        </DialogHeader>
        <div className="max-h-[80vh] p-4 overflow-auto small-scrollbar">
          <MutationForm onClose={() => handleDialog(false)} />
        </div>
        <DialogFooter>
          <Button
            className="w-full"
            form="mutation-form"
            type="submit"
            variant="success"
          >
            {t("create")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
